import { connect } from 'react-redux';
import { AnyAction, Dispatch } from 'redux';
import * as ModalActions from '../../../../common/actions/ModalActions';
import * as PipefyDataActions from '../actions/PipefyDataActions';
import SendToPipefyConfirmView from '../components/views/SendToPipefyConfirmView';
import { SendToPipefyConfirmStateProps, SendToPipefyConfirmDispatchProps } from '../types/containers';

const mapStateToProps = (state, ownProps): SendToPipefyConfirmStateProps => ({
    bankName: ownProps.data?.bank?.value || ''
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>, ownProps): SendToPipefyConfirmDispatchProps => ({
    onCancel: () => dispatch(ModalActions.CLOSE_MODAL_ACTION.action()),
    onConfirm: () => {
        dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
        dispatch(PipefyDataActions.SEND_TO_PIPEFY_REQUEST_ACTION.action(ownProps.data?.bank));
    }
});

const SendToPipefyConfirmContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SendToPipefyConfirmView);

export default SendToPipefyConfirmContainer;
